import { Pipe } from '@angular/core';
var FloorPipe = (function () {
    function FloorPipe() {
    }
    FloorPipe.prototype.transform = function (num, precision) {
        if (precision === void 0) { precision = 0; }
        if (precision <= 0) {
            return Math.floor(num);
        }
        var tho = Math.pow(10, precision);
        return Math.floor(num * tho) / tho;
    };
    return FloorPipe;
}());
export { FloorPipe };
FloorPipe.decorators = [
    { type: Pipe, args: [{ name: 'floor' },] },
];
/** @nocollapse */
FloorPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=floor.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/math/floor.js
// module id = 237
// module chunks = 4